import { render } from "./OrderLesson.vue?vue&type=template&id=f8737828&scoped=true"
import script from "./OrderLesson.vue?vue&type=script&lang=js"
export * from "./OrderLesson.vue?vue&type=script&lang=js"

import "./OrderLesson.vue?vue&type=style&index=0&id=f8737828&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8737828"]])

export default __exports__